import { CustomerInfoDto } from './MooringOffers';
import { MooringSiteSetupDto } from './MooringSiteSetup';

export class MooringDto {
  Id!: number;
  Title!: string;

  CustomerId!: number;
  Customer!: CustomerInfoDto;

  SalesPersonId!: string;

  SiteId!: number;
  SiteSetupId!: number;
  SiteSetup!: MooringSiteSetupDto;

  AnalysisAttachmentId!: string;

  CreatedAt!: Date;

  UpdatedAt!: Date;
}
